<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 850px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: center;
  flex-wrap:wrap;
  overflow: auto;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/img/产品及服务/基因调控/基因编辑/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>shRNA慢病毒质粒构建</h1>
      <h2 class="mt10">Construction of shRNA Lentiviral Plasmid</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;">擎科生物采用无复制能力的慢病毒载体来表达 shRNA。shRNA慢病毒质粒可以通过直接转染导入细胞，也可以包装成慢病毒颗粒，再来感染靶细胞。载体上编码的抗性标记（PURO/NEO等）可以方便地进行稳转株筛选；还可以利用荧光标记（GFP/RFP)观察转染/感染效率，进行流式筛选。</p>
        <div class="gene_img con" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/shRNA1.jpg"  style="margin-bottom: 50px;"></div>
        <div class="gene_img con" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto"><img src="@/assets/img/产品及服务/基因调控/基因干扰/shRNA2.jpg"></div>
        <div class="gene_img cons" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/shRNA1.jpg"  style="margin-bottom: 50px;"></div>
        <div class="gene_img cons" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto"><img src="@/assets/img/产品及服务/基因调控/基因干扰/shRNA2_2.jpg"></div>
      </div>
      <div class="container">
        <div class="c-title">shRNA慢病毒质粒构建服务项目</div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="产品大类">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="单位">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="包装">
            </el-table-column>
            <el-table-column
              prop="method5"
              label="周期/工作日">
            </el-table-column>
            <el-table-column
              prop="method6"
              label="擎科报价（元）">
            </el-table-column>
            <el-table-column
              prop="method7"
              label="备注">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists" style="display: flex!important; justify-content: center!important;">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/gr_${item.img}${currentService===index ? '' : ''}.png`" style="width: 50px;height: 55px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData:[
        {
          method1:'载体构建',
          method2:'shRNA载体构建单条定制',
          method3:'个',
          method4:'5 μg质粒+菌株',
          method5:'2周',
          method6:'300',
          method7:'不含对照 不承诺效果 质粒未去内毒素，不可直接转染细胞',
        },
        {
          method1:'载体构建',
          method2:'shRNA载体构建四保一（送NC）',
          method3:'套',
          method4:'5 μg质粒+菌株',
          method5:'2周',
          method6:'1600',
          method7:'质粒未去内毒素，不可直接转染细胞  承诺转染效率达到80%的情况下，至少有一条干扰效率达到70%。',
        },
        {
          method1:'载体构建',
          method2:'shRNA载体构建四保一（即用型、送NC）',
          method3:'套',
          method4:'50 μg去内毒素质粒+菌株',
          method5:'2周',
          method6:'1800',
          method7:'承诺转染效率达到80%的情况下，至少有一条干扰效率达到70%。',
        },
        {
          method1:'慢病毒包装质粒',
          method2:'pMD2.G psPAX2',
          method3:'套',
          method4:'5 μg质粒+菌株',
          method5:'3个工作日',
          method6:'2400',
          method7:'用于慢病毒包装',
        }
      ],
      page: 0,
      total: 0,
      currentService:-1,
      types1: [
        // {name: 'shRNA文库构建', img: '2', ref: '/products/shRNA_library_construction'},
        {name: 'ASO/反义寡核苷酸', img: '3', ref: '/products/ASO_antisense'},
      ],
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/shRNA_lentiviral.vue